import { Box, Grid, Typography, TextField, InputAdornment, Card, CardMedia, CardContent } from '@mui/material';
import React, { useState } from 'react';
import { AppButton } from '../../../../Components/AppButton';
import { useStyles } from '../../style';
import SearchIcon from '@mui/icons-material/Search';
import KenColors from '../../../../Helpers/Themes/kenColors';
import CampaignsImg from '../../../../Assets/CampaignsImg.png';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import KeyboardBackspaceSharpIcon from '@mui/icons-material/KeyboardBackspaceSharp';
import routes from '../../../../Utils/routes';
import { useNavigate } from 'react-router-dom';

const CampaingsCard = (props: any) => {
  const classes = useStyles();
  const { campaignsStatus, setCampaignsStatus } = props;
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState('');
  const [campaigns, setCampaigns] = useState('ongoing');
  const [donationStatus, setDonationStatus] = useState(false);
  const handleSearchChange = (value: any) => {
    setSearchValue(value);
    // Handle the search functionality here
    console.log('Search Value:', value);
  };
  const handleClick = () => {
    navigate(routes.fundraise);
  };
  return (
    <Box
      className="scrollbar-cusgray"
      sx={{
        height: { lg: '68.5vh', xl: '68.5vh' },
        '@media (min-width: 1270px) and (max-width: 1290px)': {
          height: '80vh !important',
        },
        '@media (min-width: 1536px) and (max-width: 1636px)': {
          height: '67.5vh !important',
        },
        '@media (min-width: 1920px) and (max-width: 2000px)': {
          height: '71.5vh',
        },
        '@media (min-width: 1280px) and (max-width: 1300px)': {
          height: '61vh !important',
        },
      }}
    >
      {campaignsStatus == false && donationStatus == false && (
        <>
          <Box className={classes.campaingsCard}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <Typography sx={{ textAlign: 'left', fontWeight: 500, fontSize: '15px' }}>Your campaigns</Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{ display: 'flex', justifyContent: 'end' }}>
                {/* <TextField
                  variant="outlined"
                  placeholder="Search..."
                  size="small"
                  sx={{
                    width: '261px',
                    height: '36px',
                    fontSize: '12px',
                    '& .MuiOutlinedInput-root': {
                      height: '100%',
                      fontSize: '12px',
                      borderRadius: '6px',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderRadius: '6px',
                    },
                    '& .MuiInputAdornment-root': {
                      borderRadius: '6px',
                    },
                    '& .MuiInputBase-input': {
                      fontSize: '12px',
                    },
                  }}
                  value={searchValue}
                  onChange={(e) => handleSearchChange(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon style={{ fontSize: '18px' }} />
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                /> */}
              </Grid>
              {/* <Grid item xs={12} sm={12} md={12} lg={2} xl={2} style={{ display: 'flex', justifyContent: 'start' }}>
                <AppButton
                  size="small"
                  variant="contained"
                  className={classes.preferBtns}
                  others={{ color: KenColors.kenBlack, width: '100%', height: '36px' }}
                  background={KenColors.ClientPrimaryGrey}
                  onClick={() => setCampaignsStatus(true)}
                >
                  <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>View More</Typography>
                </AppButton>
              </Grid>  */}
            </Grid>
            <hr style={{ border: '1px solid #E6E6E8', marginTop: 8 }} />
            <Box sx={{ display: 'flex', justifyContent: 'start', mt: 1.5 }}>
              <AppButton
                size="small"
                variant="contained"
                className={classes.postJobBtns}
                others={{ color: campaigns == 'ongoing' ? KenColors.kenWhite : KenColors.kenBlack, borderRadius: '6px', height: '27px', width: '108px' }}
                background={campaigns == 'ongoing' ? '' : KenColors.ClientPrimaryGrey}
                onClick={() => {
                  setCampaigns('ongoing');
                }}
              >
                <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Ongoing</Typography>
              </AppButton>
              <AppButton
                size="small"
                variant="contained"
                className={classes.postJobBtns}
                others={{ color: campaigns == 'inreview' ? KenColors.kenWhite : KenColors.kenBlack, marginLeft: 15, borderRadius: '6px', height: '27px', width: '108px' }}
                background={campaigns == 'inreview' ? '' : KenColors.ClientPrimaryGrey}
                onClick={() => {
                  setCampaigns('inreview');
                }}
              >
                <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>In-review</Typography>
              </AppButton>
              <AppButton
                size="small"
                variant="contained"
                className={classes.postJobBtns}
                others={{ color: campaigns == 'completed' ? KenColors.kenWhite : KenColors.kenBlack, marginLeft: 15, borderRadius: '6px', height: '27px', width: '108px' }}
                background={campaigns == 'completed' ? '' : KenColors.ClientPrimaryGrey}
                onClick={() => {
                  setCampaigns('completed');
                }}
              >
                <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Completed</Typography>
              </AppButton>
            </Box>
            {campaigns == 'ongoing' && (
              <Card sx={{ maxWidth: '234px', mt: 1.5, borderRadius: 2, boxShadow: 'none !important', backgroundColor: '#F6F8FB' }}>
                <CardMedia component="img" alt="green iguana" height="150" image={CampaignsImg} />
                <CardContent>
                  <Typography sx={{ textAlign: 'left', fontWeight: 500, fontSize: '12px' }}>Alumni Giving Gala</Typography>
                  <Typography sx={{ textAlign: 'left', fontWeight: 400, fontSize: '10.5px' }}>Give back to your alma mater fo its myraid critical needs..</Typography>
                  <AppButton size="small" variant="contained" others={{ color: '#1A358C', borderRadius: '75px', marginTop: 10, height: '27px' }} background="#BFCEFF" fullWidth onClick={handleClick}>
                    <Typography sx={{ fontSize: '10.5px', fontWeight: 500 }}>₹60,000/₹60,00,000 raised so far</Typography>
                  </AppButton>
                </CardContent>
              </Card>
            )}
            {campaigns == 'inreview' && (
              <Card sx={{ maxWidth: '234px', mt: 1.5, borderRadius: 2, boxShadow: 'none !important', backgroundColor: '#F6F8FB' }}>
                <CardMedia component="img" alt="green iguana" height="150" image={CampaignsImg} />
                <CardContent>
                  <Typography sx={{ textAlign: 'left', fontWeight: 500, fontSize: '12px' }}>Future Builders Event</Typography>
                  <Typography sx={{ textAlign: 'left', fontWeight: 400, fontSize: '10.5px' }}>Give back to your alma mater fo its myraid critical needs..</Typography>
                  <AppButton size="small" variant="contained" others={{ color: '#695113', borderRadius: '75px', marginTop: 10, height: '27px' }} background="#FEEBBE" fullWidth onClick={handleClick}>
                    <Typography sx={{ fontSize: '10.5px', fontWeight: 500 }}>Approval Pending</Typography>
                  </AppButton>
                </CardContent>
              </Card>
            )}
            {campaigns == 'completed' && (
              <Card sx={{ maxWidth: '234px', mt: 1.5, borderRadius: 2, boxShadow: 'none !important', backgroundColor: '#F6F8FB' }}>
                <CardMedia component="img" alt="green iguana" height="150" image={CampaignsImg} />
                <CardContent>
                  <Typography sx={{ textAlign: 'left', fontWeight: 500, fontSize: '12px' }}>Legacy Fundraiser</Typography>
                  <Typography sx={{ textAlign: 'left', fontWeight: 400, fontSize: '10.5px' }}>Give back to your alma mater fo its myraid critical needs..</Typography>
                  <AppButton size="small" variant="contained" others={{ color: '#1F4E21', borderRadius: '75px', marginTop: 10, height: '27px' }} background="#C1DCC3" fullWidth onClick={handleClick}>
                    <Typography sx={{ fontSize: '10.5px', fontWeight: 500 }}>₹70,10,000/₹60,00,000 raised</Typography>
                  </AppButton>
                </CardContent>
              </Card>
            )}
          </Box>
          <Box className={`${classes.campaingsCard} ${classes.campaingsCard1}`}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                <Typography sx={{ textAlign: 'left', fontWeight: 500, fontSize: '15px' }}>Your recent donations</Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={12} xl={4} lg={4} style={{ display: 'flex', justifyContent: 'end' }}>
                <TextField
                  variant="outlined"
                  placeholder="Search..."
                  size="small"
                  sx={{
                    width: '261px',
                    height: '36px',
                    fontSize: '12px',
                    '& .MuiOutlinedInput-root': {
                      height: '100%',
                      fontSize: '12px',
                      borderRadius: '6px',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderRadius: '6px',
                    },
                    '& .MuiInputAdornment-root': {
                      borderRadius: '6px',
                    },
                    '& .MuiInputBase-input': {
                      fontSize: '12px',
                    },
                  }}
                  value={searchValue}
                  onChange={(e) => handleSearchChange(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon style={{ fontSize: '18px' }} />
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} xl={2} lg={2} style={{ display: 'flex', justifyContent: 'start' }}>
                <AppButton
                  size="small"
                  variant="contained"
                  className={classes.preferBtns1}
                  others={{ color: KenColors.kenBlack, height: '36px', width: '144px' }}
                  background={KenColors.ClientPrimaryGrey}
                  onClick={() => setDonationStatus(true)}
                >
                  <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>View More</Typography>
                </AppButton>
              </Grid>
            </Grid>
            <hr style={{ border: '1px solid #E6E6E8', marginTop: 8 }} />
            <Box>
              <Grid container className={classes.donation} sx={{ minWidth: '600px', mt: 1 }}>
                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                  <Typography sx={{ color: '#8C8E94', fontWeight: 500, textAlign: 'left', fontSize: '12px' }}>Fund for</Typography>
                  <Typography sx={{ fontWeight: 500, textAlign: 'left', mt: 0.5, fontSize: '12px' }}>Scholarships</Typography>
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                  <Typography sx={{ color: '#8C8E94', fontWeight: 500, textAlign: 'left', fontSize: '12px' }}>Date</Typography>
                  <Typography sx={{ fontWeight: 500, textAlign: 'left', mt: 0.5, fontSize: '12px' }}>05-05-2024</Typography>
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                  <Typography sx={{ color: '#8C8E94', fontWeight: 500, textAlign: 'left', fontSize: '12px' }}>Time</Typography>
                  <Typography sx={{ fontWeight: 500, textAlign: 'left', mt: 0.5, fontSize: '12px' }}>1:00 PM</Typography>
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                  <Typography sx={{ color: '#8C8E94', fontWeight: 500, textAlign: 'left', fontSize: '12px' }}>Amount</Typography>
                  <Typography sx={{ fontWeight: 500, textAlign: 'left', mt: 0.5, fontSize: '12px' }}>₹50,000</Typography>
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                  <Typography sx={{ color: '#8C8E94', fontWeight: 500, textAlign: 'left', fontSize: '12px' }}>Payment Method</Typography>
                  <Typography sx={{ fontWeight: 500, textAlign: 'left', mt: 0.5, fontSize: '12px' }}>Google Pay</Typography>
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2} xl={2} display={'flex'} justifyContent={'end'}>
                  <Box className={classes.iconBox}>
                    <SaveAltIcon
                      sx={{
                        fontSize: '18px',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </>
      )}
      {campaignsStatus == true && (
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={8.5} xl={8.5} sx={{ display: 'flex', justifyContent: 'start', mt: 0.5 }}>
              <KeyboardBackspaceSharpIcon sx={{ mt: 0.2 }} onClick={() => setCampaignsStatus(false)} />
              &nbsp;
              <Typography sx={{ textAlign: 'left', fontWeight: 580, fontSize: 19 }}>Your campaigns</Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={3.5} xl={3.5} style={{ display: 'flex', justifyContent: 'end' }}>
              <TextField
                variant="outlined"
                placeholder="search..."
                size="small"
                sx={{
                  borderRadius: 2,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderRadius: 2,
                  },
                  '& .MuiInputAdornment-root': {
                    borderRadius: 2,
                  },
                }}
                value={searchValue}
                onChange={(e: any) => handleSearchChange(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                fullWidth
              />
            </Grid>
          </Grid>
          <div className={classes.campaingsCard}>
            <Box sx={{ display: 'flex', justifyContent: 'start', mt: 1.5 }}>
              <AppButton
                size="small"
                variant="contained"
                className={classes.postJobBtns}
                others={{ color: campaigns == 'ongoing' ? KenColors.kenWhite : KenColors.kenBlack }}
                background={campaigns == 'ongoing' ? '' : KenColors.ClientPrimaryGrey}
                onClick={() => {
                  setCampaigns('ongoing');
                }}
              >
                Ongoing
              </AppButton>
              <AppButton
                size="small"
                variant="contained"
                className={classes.postJobBtns}
                others={{ color: campaigns == 'inreview' ? KenColors.kenWhite : KenColors.kenBlack, marginLeft: 15 }}
                background={campaigns == 'inreview' ? '' : KenColors.ClientPrimaryGrey}
                onClick={() => {
                  setCampaigns('inreview');
                }}
              >
                In-review
              </AppButton>
              <AppButton
                size="small"
                variant="contained"
                className={classes.postJobBtns}
                others={{ color: campaigns == 'completed' ? KenColors.kenWhite : KenColors.kenBlack, marginLeft: 15 }}
                background={campaigns == 'completed' ? '' : KenColors.ClientPrimaryGrey}
                onClick={() => {
                  setCampaigns('completed');
                }}
              >
                Completed
              </AppButton>
            </Box>
            {campaigns == 'ongoing' && (
              <Card sx={{ maxWidth: 345, mt: 1.5, borderRadius: 2, boxShadow: 'none !important' }}>
                <CardMedia component="img" alt="green iguana" height="150" image={CampaignsImg} />
                <CardContent>
                  <Typography sx={{ textAlign: 'left', fontWeight: 550, fontSize: 18 }}>Alumni Giving Gala</Typography>
                  <Typography sx={{ textAlign: 'left' }}>Give back to your alma mater fo its myraid critical needs..</Typography>
                  <AppButton size="small" variant="contained" others={{ color: '#1A358C', borderRadius: 20, marginTop: 10 }} background="#BFCEFF" fullWidth onClick={handleClick}>
                    ₹60,000/₹60,00,000 raised so far
                  </AppButton>
                </CardContent>
              </Card>
            )}
            {campaigns == 'inreview' && (
              <Card sx={{ maxWidth: 345, mt: 1.5, borderRadius: 2, boxShadow: 'none !important' }}>
                <CardMedia component="img" alt="green iguana" height="150" image={CampaignsImg} />
                <CardContent>
                  <Typography sx={{ textAlign: 'left', fontWeight: 550, fontSize: 18 }}>Future Builders Event</Typography>
                  <Typography sx={{ textAlign: 'left' }}>Give back to your alma mater fo its myraid critical needs..</Typography>
                  <AppButton size="small" variant="contained" others={{ color: '#1A358C', borderRadius: 20, marginTop: 10 }} background="#f9bb71" fullWidth onClick={handleClick}>
                    Approval Pending
                  </AppButton>
                </CardContent>
              </Card>
            )}
            {campaigns == 'completed' && (
              <Card sx={{ maxWidth: 345, mt: 1.5, borderRadius: 2, boxShadow: 'none !important' }}>
                <CardMedia component="img" alt="green iguana" height="150" image={CampaignsImg} />
                <CardContent>
                  <Typography sx={{ textAlign: 'left', fontWeight: 550, fontSize: 18 }}>Legacy Fundraiser</Typography>
                  <Typography sx={{ textAlign: 'left' }}>Give back to your alma mater fo its myraid critical needs..</Typography>
                  <AppButton size="small" variant="contained" others={{ color: '#1A358C', borderRadius: 20, marginTop: 10 }} background="#b2c885" fullWidth onClick={handleClick}>
                    ₹70,10,000/₹60,00,000 raised
                  </AppButton>
                </CardContent>
              </Card>
            )}
          </div>
        </Box>
      )}
      {donationStatus == true && (
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={8.5} xl={8.5} sx={{ display: 'flex', justifyContent: 'start', mt: 0.5 }}>
              <KeyboardBackspaceSharpIcon sx={{ mt: 0.2 }} onClick={() => setDonationStatus(false)} />
              &nbsp;
              <Typography sx={{ textAlign: 'left', fontWeight: 500, fontSize: '15px', ml: 1 }}>Recent donations</Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={3.5} xl={3.5} style={{ display: 'flex', justifyContent: 'end' }}>
              <TextField
                variant="outlined"
                placeholder="search..."
                size="small"
                sx={{
                  borderRadius: 2,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderRadius: 2,
                  },
                  '& .MuiInputAdornment-root': {
                    borderRadius: 2,
                  },
                }}
                value={searchValue}
                onChange={(e: any) => handleSearchChange(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                fullWidth
              />
            </Grid>
          </Grid>
          <div>
            <Box sx={{ height: 625 }}>
              {/* <div style={{ overflowX: 'auto' }}> */}
              <Grid container className={classes.donation} sx={{ minWidth: '600px', mt: 1 }}>
                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                  <Typography sx={{ color: '#8C8E94', fontWeight: 500, textAlign: 'left', fontSize: '12px' }}>Fund for</Typography>
                  <Typography sx={{ fontWeight: 500, textAlign: 'left', mt: 0.5, fontSize: '12px' }}>Scholarships</Typography>
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                  <Typography sx={{ color: '#8C8E94', fontWeight: 500, textAlign: 'left', fontSize: '12px' }}>Date</Typography>
                  <Typography sx={{ fontWeight: 500, textAlign: 'left', mt: 0.5, fontSize: '12px' }}>05-05-2024</Typography>
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                  <Typography sx={{ color: '#8C8E94', fontWeight: 500, textAlign: 'left', fontSize: '12px' }}>Time</Typography>
                  <Typography sx={{ fontWeight: 500, textAlign: 'left', mt: 0.5, fontSize: '12px' }}>1:00 PM</Typography>
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                  <Typography sx={{ color: '#8C8E94', fontWeight: 500, textAlign: 'left', fontSize: '12px' }}>Amount</Typography>
                  <Typography sx={{ fontWeight: 500, textAlign: 'left', mt: 0.5, fontSize: '12px' }}>₹50,000</Typography>
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                  <Typography sx={{ color: '#8C8E94', fontWeight: 500, textAlign: 'left', fontSize: '12px' }}>Payment Method</Typography>
                  <Typography sx={{ fontWeight: 500, textAlign: 'left', mt: 0.5, fontSize: '12px' }}>Google Pay</Typography>
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2} xl={2} display={'flex'} justifyContent={'end'}>
                  <Box className={classes.iconBox}>
                    <SaveAltIcon
                      sx={{
                        fontSize: '18px',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
              {/* </div> */}
            </Box>
          </div>
        </Box>
      )}
    </Box>
  );
};

export default CampaingsCard;
